import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 60000,
  withCredentials: true,
});

const keyHeader = (key) => ({ headers: { 'X-Attempt-Key': key } });

// Internal (signed-in users)
export const getAssessmentLibrary = async () => (await api.get('/assessments/library')).data;
export const getAssessmentTest = async (testId) => (await api.get(`/assessments/tests/${testId}`)).data;
export const updateAssessmentPublicLink = async (testId, body) => (await api.post(`/assessments/tests/${testId}/public-link`, body)).data;
export const updateAssessmentConfig = async (testId, body) => (await api.put(`/assessments/tests/${testId}/config`, body)).data;
export const getAssessmentAttempts = async (testId) => (await api.get(`/assessments/tests/${testId}/attempts`)).data;
export const getAssessmentInvites = async (testId) => (await api.get(`/assessments/tests/${testId}/invites`)).data;
export const createAssessmentInvite = async (testId, body) => (await api.post(`/assessments/tests/${testId}/invites`, body)).data;
export const revokeAssessmentInvite = async (inviteId) => (await api.delete(`/assessments/invites/${inviteId}`)).data;
export const getAttemptReport = async (attemptId) => (await api.get(`/assessments/attempts/${attemptId}/report`)).data;

// Public candidate flow
export const getPublicAssessment = async (token) => (await api.get(`/assess/public/${token}`)).data;
export const startAssessment = async (token, body) => (await api.post(`/assess/public/${token}/start`, body)).data;
export const resumeAssessment = async (attemptId, key) => (await api.get(`/assess/attempt/${attemptId}`, keyHeader(key))).data;
export const saveAssessment = async (attemptId, key, body) => (await api.put(`/assess/attempt/${attemptId}/save`, body, keyHeader(key))).data;
export const submitAssessment = async (attemptId, key, body) => (await api.post(`/assess/attempt/${attemptId}/submit`, body, keyHeader(key))).data;
// Fire-and-forget save that survives page unload (keepalive bodies are capped at 64KB, so the snapshot may be dropped)
export const saveAssessmentKeepalive = (attemptId, key, body) => {
  let data = JSON.stringify(body);
  if (data.length > 60000) data = JSON.stringify({ ...body, snapshot_json: undefined });
  if (data.length > 60000) return;
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/assess/attempt/${attemptId}/save`, {
    method: 'PUT', keepalive: true, body: data, headers: { 'Content-Type': 'application/json', 'X-Attempt-Key': key },
  }).catch(() => {});
};

// Public report
export const getSharedAssessmentReport = async (shareToken) => (await api.get(`/assess/report/${shareToken}`)).data;
export const assessmentPdfUrl = (shareToken) => `${process.env.REACT_APP_BACKEND_URL}/api/assess/report/${shareToken}/pdf`;
export const assessmentTakeUrl = (token) => `${window.location.origin}/assessment/${token}`;
export const assessmentReportUrl = (shareToken) => `${window.location.origin}/assessment-report/${shareToken}`;

export const apiError = (e, fallback = 'Something went wrong') => e?.response?.data?.detail || fallback;

// Each region has its own public link; fall back to the first region the user can see
export const pickRegionLink = (links, region) => {
  const r = links?.[region] ? region : Object.keys(links || {})[0];
  return [r, (links || {})[r] || {}];
};
